import { lazy, Suspense } from "react";
import MapSkeleton from "../../Components/Common/Map/MapSkeleton";

/**
 * Kept as `MapBox` so existing call sites don't change. It used to be Leaflet
 * pointed at MapTiler (with a hardcoded key); it is now Mapbox GL.
 *
 * Loaded lazily: mapbox-gl is ~400 kB gzipped and only two screens show a map,
 * so it must not sit in the bundle every page pays for.
 */
const MapboxMap = lazy(() => import("../../Components/Common/Map/MapboxMap"));

export default function MapBox({ height = 400, width = "100%", ...rest }) {
  return (
    <Suspense fallback={<MapSkeleton height={height} width={width} />}>
      <MapboxMap height={height} width={width} {...rest} />
    </Suspense>
  );
}
